import React, { ReactNode, useState } from 'react';
import { css } from '@emotion/core';
import SyncLoader from 'react-spinners/SyncLoader';
import classNames from 'classnames';
import styles from './styles.module.scss';
const override = css`
  position: absolute;
  z-index: 999;
`;
interface IProps {
  children?: ReactNode;
}

export default function LoadingScreen({ children }: IProps) {
  return (
    <div className={styles.sweetLoading}>
      <SyncLoader css={override} size={20} color={'#0d20cf'} loading={true} />
      <div className={styles.backgroundLoading}></div>
    </div>
  );
}
// backgroundLoading
